
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Layouts/RootPortal.html",
      function () {
        return require("private-next-pages/Layouts/RootPortal.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Layouts/RootPortal.html"])
      });
    }
  